import { departmentFragments } from "@/queries/Department";
import gql from "graphql-tag";

export const GET_DEPARTMENT = gql`
  query department($id: ID!) {
    department(id: $id) {
      ...departmentFragments,
    }
  },
  ${departmentFragments}
`;
